import actionTypes from './actionTypes';
import getActionCreator from '../libs/getActionCreator';

export const getResultsAction = getActionCreator(actionTypes.GET_RESULTS);

export const getResults = getActionCreator(actionTypes.GET_RESULTS);
